import { render } from "./Audios.vue?vue&type=template&id=0a08d7b4&scoped=true"
import script from "./Audios.vue?vue&type=script&lang=js"
export * from "./Audios.vue?vue&type=script&lang=js"

import "./Audios.vue?vue&type=style&index=0&id=0a08d7b4&scoped=true&lang=css"

import exportComponent from "/pro/vue/Attamayyuz_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a08d7b4"]])

export default __exports__